import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import routes from './routes'
import { useUserStore } from 'stores/user'
import { normalizeOrganisationSettingsModuleKey } from 'src/shared/lib/organisationSettingsModuleRoutes'

const LAST_NON_LOGIN_ROUTE_KEY = 'last-non-login-route'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function ({ store /*, ssrContext */ }) {
  const createHistory = import.meta.env.QUASAR_SERVER
    ? createMemoryHistory
    : (import.meta.env.QUASAR_VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(import.meta.env.QUASAR_VUE_ROUTER_BASE)
  })

  router.beforeEach((to) => {
    if (typeof window !== 'undefined' && to?.name !== 'login') {
      try {
        window.sessionStorage.setItem(LAST_NON_LOGIN_ROUTE_KEY, String(to.fullPath || ''))
      } catch {
        // Ignore storage write errors and keep navigation functional.
      }
    }

    if (to?.meta?.modul) {
      const user = useUserStore(store)
      user.saveCurrentModul(to.meta.modul)
    } else if (['OrganisationSettings', 'InterfaceSettings', 'ClientSearch'].includes(String(to?.name || ''))) {
      const user = useUserStore(store)
      const moduleKey = normalizeOrganisationSettingsModuleKey(to?.params?.moduleSlug)
      user.saveCurrentModul(moduleKey)
    }
    return true
  })

  return router
})
